import React from "react";

const ApiDoc = () => {
    return (
        <div className="doc_page_cont">
            <p className="doc_page_cont_title">API Keys</p>

            <p className="doc_page_cont_paragraph">
                API Keys are your secure access tokens to interact with <strong>Erioon</strong> project resources. 
                They authenticate your applications and control access to your databases and collections.
                Keep your keys safe and avoid exposing them in public repositories or client-side code.
            </p>

            <p className="doc_page_cont_subtitle">Generating an API Key</p>
            <p className="doc_page_cont_paragraph">
                To generate an API Key:
            </p>
            <ol className="list_cont_doc">
                {/* <li>Log in to your <a href="https://www.erioon.com/login" className="text-blue-400">Erioon Dashboard</a>  and choose a your project</li> */}
                <li>Log in</li>
                <li>Navigate to the <strong>API Keys</strong> section</li>
                <li>Click '<strong><i className="fa-solid fa-plus"></i> Create</strong>' and assign a API key Name for identification</li>
                <li>Copy your key immediately, for security reasons, it will not be shown again</li>
            </ol>

            <p className="doc_page_cont_subtitle">Best Practices</p>
            <ul className="list_cont_doc">
                <li>Never expose API keys in client-side code</li>
                <li>Use environment variables to securely store your keys</li>
                <li>Regenerate your keys if you suspect they have been compromised</li>
                <li>Use separate keys for different environments (development, production)</li>
            </ul>
        </div>
    );
}

export default ApiDoc